import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/scss/pagination.module.scss";

interface Props {
    totalItems: number;
    itemCountPerPage: number;
    pageCount: number;
    currentPage: number;
}

export default function Pagination({ totalItems, itemCountPerPage, pageCount, currentPage }: Props) {
    const totalPages = Math.ceil(totalItems / itemCountPerPage);
    const [start, setStart] = useState(1);
    const [nextExist, setNextExist] = useState(start + pageCount - 1 >= totalPages);
    const noPrev = start === 1;
    //onst noNext = start + pageCount - 1 >= totalPages;

    useEffect(() => {
        if (currentPage === start + pageCount) setStart((prev) => prev + pageCount);
        if (currentPage < start) setStart((prev) => prev - pageCount);
        if (start + pageCount - 1 >= totalPages) {
            setNextExist(false);
        } else {
            setNextExist(true);
        }
    }, [currentPage, pageCount, start, totalPages]);

    useEffect(() => {
        if (start + pageCount - 1 >= totalPages) {
            setNextExist(false);
        } else {
            setNextExist(true);
        }
    }, [])

    return (
        <div className="flex items-center justify-center text-gray-200">
            <ul className="flex">
                <li>
                    {!noPrev ? <Link className="mx-6 text-sm underline underline-offset-4 text-cyan-400" to={`?page=${start - 1}`}>이전</Link> : ""}
                </li>
                {[...Array(pageCount)].map((a, i) => (
                    <>
                        {start + i <= totalPages && (
                            <li key={i} className={`mx-1 px-2  ${start + i === currentPage ? 'ring-1 ring-indigo-600 rounded-full bg-slate-500 text-black font-bold' : ''}`}>
                                <Link
                                    to={`?page=${start + i}`}>
                                    {start + i}
                                </Link>
                            </li>
                        )}
                    </>
                ))}
                <li>
                    {nextExist ? <Link className="mx-6  text-sm underline underline-offset-4 text-cyan-400" to={`?page=${start + pageCount}`}>다음</Link> : ""}
                </li>
            </ul>
        </div>
    );
}